import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_SNAP = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GENERAL_SNAP' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'>
                    This worksheet will help us talk with you about your mental health treatment here at InnerSourced Solutions. There are
                    four partsfor you to share with us about your Strengths, Needs, Abilities and Preferences. Please check and/or list the
                    items which best fit you at this time.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>STRENGTHS</span>
                </p>
                <p className='w-750'>
                    <span className='small'>What personal qualities do you have which we can build upon in treatment?</span>
                </p>
                <table>
                    <tr>
                        <td className='w-275'>
                            <input type="checkbox" name="cbRsponsibility" id="cbResponsibility" className='add-only' value="Takes personal responsibility" />
                            Takes personal responsibility
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbOpenMinded" id="cbOpenMinded" className='add-only' value="Open minded" />
                            Open minded
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbFriendly" id="cbFriendly" className='add-only' value="Friendly" />
                            Friendly
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbGoodListener" id="cbGoodListener" className='add-only' value="Good Listener" />
                            Good Listener
                        </td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            <input type="checkbox" name="cbSpiritualValues" id="cbSpiritualValues" className='add-only' value="Strong personal or spiritual values" />
                            Strong personal or spiritual values
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbCreative" id="cbCreative" className='add-only' value="Creative" />
                            Creative
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbQuickLearner" id="cbQuickLearner" className='add-only' value="Quick Learner" />
                            Quick Learner
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbOrganized1" id="cbOrganized1" className='add-only' value="Organized" />
                            Organized
                        </td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            <input type="checkbox" name="cbExperiences" id="cbExperiences" className='add-only' value="Able to learn from my experiences" />
                            Able to learn from my experiences
                        </td>

                        <td className='w-160'>
                            <input type="checkbox" name="cbOrganized" id="cbOrganized" className='add-only' value="Organized" />
                            Organized
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbGoodGrooming" id="cbGoodGrooming" className='add-only' value="Good Grooming" />
                            Good Grooming
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbIndependent" id="cbIndependent" className='add-only' value="Independent" />
                            Independent
                        </td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            <input type="checkbox" name="cbCanCollaborate" id="cbCanCollaborate" className='add-only' value="Can collaborate/ work with others" />
                            Can collaborate/ work with others
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbAssertive" id="cbAssertive" className='add-only' value="Assertive" />
                            Assertive
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbHardWorker" id="cbHardWorker" className='add-only' value="Hard Worker" />
                            Hard Worker
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbMotivation" id="cbMotivation" className='add-only' value="Motivation" />
                            Motivation
                        </td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            <input type="checkbox" name="cbProblemSolver" id="cbProblemSolver" className='add-only' value="Good Problem Solver" />
                            Good Problem Solver
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbDependable" id="cbDependable" className='add-only' value="Dependable" />
                            Dependable
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbGoodHealth" id="cbGoodHealth" className='add-only' value="Good health" />
                            Good health
                        </td>
                    </tr>
                    <tr>
                        <td className='w-275'>
                            <input type="checkbox" name="cbDecisionMaker" id="cbDecisionMaker" className='add-only' value="Good Decision Maker" />
                            Good Decision Maker
                        </td>
                        <td className='w-160'>
                            <input type="checkbox" name="cbOther" id="cbOther" className='add-only' value="Other (Please List)" />
                            Other (Please List)
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea name="txtOther1" id="txtOther1" className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>NEEDS</span>
                </p>
                <p className='w-750'>
                    What would help you achieve your goals? Please, check your most important needs.
                </p>
                <p className='w-750'>
                    <span className='small'>(Priortize your top three)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="cbknowledge" id="cbknowledge" className='add-only' value="Increase my knowledge of resources that provide me with support" />
                            Increase my knowledge of resources that provide me with support
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="cbEducation" id="cbEducation" className='add-only' value="Referral to resources for job training or education" />
                            Referral to resources for job training or education
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="cbMedicalCare" id="cbMedicalCare" className='add-only' value="Access to medical care for health-related concerns" />
                            Access to medical care for health-related concerns
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="cbSoberEnvironment" id="cbSoberEnvironment" className='add-only' value="Staying in a sober environment to help  me not use drugs and or alcohol" />
                            Staying in a sober environment to help  me not use drugs and or alcohol
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-30'>
                            <input type="checkbox" id="cbMoreKnowledge" name="cbMoreKnowledge" className='add-only' value="Gain More Knowledge and understanding about:" />
                        </td>
                        <td className='w-750'>Gain More Knowledge and understanding about:</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbMentalHealth" name="cbMentalHealth" className='add-only' value="My mental health diagnosis" />
                        </td>
                        <td className='w-650'>My mental health diagnosis</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbMedications" name="cbMedications" className='add-only' value="My medication(s)" />
                        </td>
                        <td className='w-650'>My medication(s)</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbSymptoms" name="cbSymptoms" className='add-only' value="My symptoms / behaviors related to my mental health diagnosis" />
                        </td>
                        <td className='w-650'>My symptoms / behaviors related to my mental health diagnosis</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbStopSmoking" name="cbStopSmoking" className='add-only' value="Get help to stop smoking" />
                        </td>
                        <td className='w-650'>Get help to stop smoking</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbEmpowerMyself" name="cbEmpowerMyself" className='add-only' value="Learn how to empower myself to take a more active role in my treatment" />
                        </td>
                        <td className='w-650'>Learn how to empower myself to take a more active role in my treatment</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbCommunicationSkills" name="cbCommunicationSkills" className='add-only' value="Increasing effective communication skills to improve my relationships with others" />
                        </td>
                        <td className='w-650'>Increasing effective communication skills to improve my relationships with others</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbMyConcerns" name="cbMyConcerns" className='add-only' value="Learn how to talk about my concerns/issues/feelings" />
                        </td>
                        <td className='w-650'>Learn how to talk about my concerns/issues/feelings</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbSafeEnvironment" name="cbSafeEnvironment" className='add-only' value="Practice my coping skills in a safe environment" />
                        </td>
                        <td className='w-650'>Practice my coping skills in a safe environment</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-30'>
                            <input type="checkbox" id="cbEffectiveCoping" name="cbEffectiveCoping" className='add-only' value="Learn more about effective coping skills related to:" />
                        </td>
                        <td className='w-750'>Learn more about effective coping skills related to:</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbReducingAnxiety" name="cbReducingAnxiety" className='add-only' value="Reducing anxiety and using relaxation" />
                        </td>
                        <td className='w-650'>Reducing anxiety and using relaxation</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbImprovingMySleep" name="cbImprovingMySleep" className='add-only' value="Improving my sleep" />
                        </td>
                        <td className='w-650'>Improving my sleep</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbLeisureSkills1" name="cbLeisureSkills1" className='add-only' value="Leisure skills" />
                        </td>
                        <td className='w-650'>Leisure skills</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbDailyActivities1" name="cbDailyActivities1" className='add-only' value="Organizing daily activities" />
                        </td>
                        <td className='w-650'>Organizing daily activities</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbMyDepression" name="cbMyDepression" className='add-only' value="Managing my depression" />
                        </td>
                        <td className='w-650'>Managing my depression</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbManagingAnger" name="cbManagingAnger" className='add-only' value="Managing anger" />
                        </td>
                        <td className='w-650'>Managing anger</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbMoodRegulation" name="cbMoodRegulation" className='add-only' value="Mood Regulation" />
                        </td>
                        <td className='w-650'>Mood Regulation</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbEatingHealthy" name="cbEatingHealthy" className='add-only' value="Eating Healthy" />
                        </td>
                        <td className='w-650'>Eating Healthy</td>
                    </tr>
                    <tr>
                        <td className='w-50'>&nbsp;</td>
                        <td className='w-30'>
                            <input type="checkbox" id="cbOther2" name="cbOther2" className='add-only' value="Other (Please List)" />
                        </td>
                        <td className='w-650'>Other (Please List)</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea name="txtOther3" id="txtOther3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Abilities</span>
                </p>
                <p className='w-750'>
                    <span className='small'>What skills do you possess?</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="cbBasicAbility" id="cbBasicAbility" className='add-only' value="Basic ability to read and write" />
                            Basic ability to read and write
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" name="cbComputerknowledge" id="cbComputerknowledge" className='add-only' value="Computer knowledge and skills" />
                            Computer knowledge and skills
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="cbEffectively" id="cbEffectively" className='add-only' value="Ability to work effectively with others" />
                            Ability to work effectively with others
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" name="cbHealthyDecisions" id="cbHealthyDecisions" className='add-only' value="Ability to make healthy decisions about my life" />
                            Ability to make healthy decisions about my life
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="cbManageMyEmotions" id="cbManageMyEmotions" className='add-only' value="Knowledge or tools that I use to help me manage my emotions" />
                            Knowledge or tools that I use to help me manage my emotions
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="cbPositiveRelationships" id="cbPositiveRelationships" className='add-only' value="Ability to have positive relationships with others" />
                            Ability to have positive relationships with others
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="cbDailyActivities" id="cbDailyActivities" className='add-only' value="Ability to manage my time and structure my daily activities" />
                            Ability to manage my time and structure my daily activities
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type="checkbox" name="cbJobSkills" id="cbJobSkills" className='add-only' value="Job Skills" />
                    Job Skills
                    <textarea name="txtJobSkills" id="txtJobSkills" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbLeisureSkills" id="cbLeisureSkills" className='add-only' value="Leisure Skills" />
                    Leisure Skills
                    <textarea name="txtLeisureSkills" id="txtLeisureSkills" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbTraining" id="cbTraining" className='add-only' value="Education / Training" />
                    Education / Training
                    <textarea name="txtTraining" id="txtTraining" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type="checkbox" name="cbOther4" id="cbOther4" className='add-only' value="Other (Please List)" />
                    Other (Please List)
                </p>
                <p className='w-750'>
                    <textarea name="txtOther5" id="txtOther5" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Preferences</span>
                </p>
                <p className='w-750'>
                    <span className='small'>How do you want your treatment?</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="cbMyFamily" id="cbMyFamily" className='add-only' value="I prefer my family or friends to be involved in my treatment" />
                            I prefer my family or friends to be involved in my treatment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" name="cbFamilyMeeting" id="cbFamilyMeeting" className='add-only' value="I would like to have a family meeting" />
                            I would like to have a family meeting
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>I learn new information better:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="cbFaceToFace" id="cbFaceToFace" className='add-only' value="Face to face" />
                            Face to face
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" name="cbAlone" id="cbAlone" className='add-only' value="Alone" />
                            Alone
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="cbPractice" id="cbPractice" className='add-only' value="Hands on instruction and practice" />
                            Hands on instruction and practice
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" name="cbWrittenMaterial" id="cbWrittenMaterial" className='add-only' value="Reading written material" />
                            Reading written material
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="cbSharingInformation" id="cbSharingInformation" className='add-only' value="Sharing information in a group of my peers" />
                            Sharing information in a group of my peers
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" name="cbDiscussion" id="cbDiscussion" className='add-only' value="In discussion with others" />
                            In discussion with others
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>I would like to live:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbIndependently" id="cbIndependently" className='add-only' value="Independently, on my own" />
                            Independently, on my own
                        </td>
                        <td className='w-550'>
                            <input type="checkbox" name="cbIndependently1" id="cbIndependently1" className='add-only' value="Independently, with community support" />
                            Independently, with community support
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbOthers6" id="cbOthers6" className='add-only' value="With others" />
                            With others
                        </td>
                        <td className='w-550'>
                            <input type="checkbox" name="cbLivingSituation" id="cbLivingSituation" className='add-only' value="Other ideas I have about my living situation (Please List)" />
                            Other ideas I have about my living situation (Please List)
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea name="txtOther7" id="txtOther7" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>I am interested in learning more about:</span>
                </p>
                <table>
                    <tr>
                        <td className='w-200'>
                            <input type="checkbox" name="cbOutpatientProgramming" id="cbOutpatientProgramming" className='add-only' value="Outpatient programming" />
                            Outpatient programming
                        </td>
                        <td className='w-200'>
                            <input type="checkbox" name="cbCommunityResources" id="cbCommunityResources" className='add-only' value="Community resources" />
                            Community resources
                        </td>
                        <td className='w-350'>
                            <input type="checkbox" name="cbCommunityResources1" id="cbCommunityResources1" className='add-only' value="Community resources" />
                            Other areas of interest (Please List)
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea name="txtAreasOfInterest" id="txtAreasOfInterest" className='add-only'></textarea>
                </p>





            </div>
        </form >
    )
}